import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StickerComponent } from 'src/business/sticker/sticker.component';
import { MediaModule } from 'src/layout/media/media.module';
import { ImageWithLinkComponent } from './image-with-link.component';

@NgModule({
    declarations: [
        ImageWithLinkComponent,
    ],

    imports: [CommonModule, MediaModule, StickerComponent, RouterModule],
})
export class ImageWithLinkModule {
    static components = { 'imageWithLink': ImageWithLinkComponent };
}
